((SlidingAnnouncements, $) => {
    'use strict';
  
    const slidingAnnouncements = () => {
        const slidingAnnouncementsSlides = $('.sliding-announcements__slides');
        const seconds = slidingAnnouncementsSlides.data('seconds');

        slidingAnnouncementsSlides.on('init', function(event, slick, direction){
            slidingAnnouncementsSlides.addClass('sliding-announcements__slides--is-active');
        });
          
        slidingAnnouncementsSlides.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: `${seconds}000`,
            adaptiveHeight: true,
            infinite: false,
            nextArrow: '.next-arrow',
            prevArrow: '.prev-arrow'
        });
    };
  
    const init = () => {
        if($('.sliding-announcements__slide').length > 1) {
            slidingAnnouncements();
        }
    };
  
    SlidingAnnouncements.init = init;
  
})(window.SlidingAnnouncements = window.SlidingAnnouncements || {}, jQuery);